import React, { useState, useEffect } from 'react';
import SharedHelmet from "../Helmet";
import { FirstAds, SecondAds, MobileUnderCalAds } from "../../Ads";
import imageUrl from "../../../images/eid-adha.webp";
import BlinkingText from '../../BlinkingText';
import RelatedLinks from '../RelatedLinks';
import MainCalculatorsList from './MainCalculators';
import moment from 'moment-hijri';

const TITLE = "Décompte jusqu'à l'Aïd al-Adha 2026 - Jours restants jusqu'à l'Aïd al-Adha 2026";
const DESCRIPTION = "Décompte jusqu'à l'Aïd al-Adha 2026 : combien de jours jusqu'à l'Aïd ? Quand est l'Aïd ? Date de l'Aïd al-Adha 2026, décompte Aïd al-Adha 2026, minuterie de décompte Aïd al-Adha, jours restants jusqu'à l'Aïd al-Adha, célébration Aïd al-Adha 2026.";
const KEYWORDS = "décompte Aïd al-Adha 2026, Aïd al-Adha date, Aïd al-Adha 2026, jours restants Aïd al-Adha, décompte fête sacrifice";
const OG_URL = "https://do-calculate.com/articles-fr/eid-adha";

function EidAdha() {
    const calculateTimeLeft = (targetDate) => {
        const now = new Date();
        const difference = targetDate - now;
        let timeLeft = {};
        if (difference > 0) {
            timeLeft = {
                days: Math.floor(difference / (1000 * 60 * 60 * 24)),
                hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
                minutes: Math.floor((difference / 1000 / 60) % 60),
                seconds: Math.floor((difference / 1000) % 60),
            };
        }
        return timeLeft;
    };

    const [eidDates] = useState([
        { name: "Aïd al-Adha 2026", date: new Date("2026-06-06T00:00:00") },
        { name: "Aïd al-Adha 2027", date: new Date("2027-05-27T00:00:00") },
        { name: "Aïd al-Adha 2028", date: new Date("2028-05-15T00:00:00") },
        { name: "Aïd al-Adha 2029", date: new Date("2029-05-05T00:00:00") },
    ]);

    const nextEid = eidDates.find(d => new Date() < d.date) || eidDates[eidDates.length - 1];
    const dayName = nextEid.date.toLocaleDateString('fr-FR', { weekday: 'long' });

    const [timeLeft, setTimeLeft] = useState(calculateTimeLeft(nextEid.date));

    useEffect(() => {
        const timer = setTimeout(() => {
            setTimeLeft(calculateTimeLeft(nextEid.date));
        }, 1000);
        return () => clearTimeout(timer);
    }, [timeLeft, nextEid]);

    return (
        <div className="ltr">
            <SharedHelmet
                TITLE={TITLE}
                DESCRIPTION={DESCRIPTION}
                KEYWORDS={KEYWORDS}
                OG_URL={OG_URL}
            />
            <div className="row">
                <FirstAds />
            </div>
            <h1 className="p-3 mb-2 bg-success text-white">
                Décompte jusqu'à l'Aïd al-Adha {nextEid.name.split(' ')[3]}
            </h1>
            <div>
                <BlinkingText
                    text={`Décompte jusqu'à l'Aïd al-Adha : l'Aïd al-Adha ${nextEid.name.split(' ')[3]} devrait avoir lieu le ${dayName} ${nextEid.date.toLocaleDateString('fr-FR')} (grégorien) et le ${moment(nextEid.date).format('iDD/iMM/iYYYY')} (hégirien).`}
                />
            </div>
            <div className="row">
                <div id="timer" style={{ width: '100%' }}>
                    <table style={{ width: '100%', textAlign: 'center', borderCollapse: 'collapse', border: '1px solid #ccc', fontSize: '24px' }}>
                        <thead>
                            <tr>
                                <th className="bmi-header">Jours</th>
                                <th className="bmi-header">Heures</th>
                                <th className="bmi-header">Minutes</th>
                                <th className="bmi-header">Secondes</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>{timeLeft.days ?? 0}</td>
                                <td>{timeLeft.hours ?? 0}</td>
                                <td>{timeLeft.minutes ?? 0}</td>
                                <td>{timeLeft.seconds ?? 0}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div className="row">
                <SecondAds />
            </div>
            <div className="row">
                <div className="col-12 col-md-8">
                    <h2 className="p-3 mb-2 bg-success text-white" style={{ fontSize: '28px', textAlign: 'center' }}>
                        Prochaines dates de l'Aïd al-Adha
                    </h2>
                    <table style={{ fontSize: '20px', width: '100%', textAlign: 'center', borderCollapse: 'collapse', border: '2px solid #ccc', borderRadius: '8px', overflow: 'hidden' }}>
                        <thead>
                            <tr style={{ backgroundColor: '#f2f2f2' }}>
                                <th style={{ padding: '16px', borderBottom: '2px solid #ccc' }}>Aïd al-Adha</th>
                                <th style={{ padding: '16px', borderBottom: '2px solid #ccc' }}>Date</th>
                                <th style={{ padding: '16px', borderBottom: '2px solid #ccc' }}>Jours restants</th>
                            </tr>
                        </thead>
                        <tbody>
                            {eidDates.map((eid, index) => (
                                <tr key={index} style={{ backgroundColor: index % 2 === 0 ? '#fff' : '#f9f9f9' }}>
                                    <td style={{ padding: '12px' }}>{eid.name}</td>
                                    <td style={{ padding: '12px' }}>{eid.date.toLocaleDateString('fr-FR')}</td>
                                    <td style={{ padding: '12px' }}>
                                        {Math.max(0, calculateTimeLeft(eid.date).days ?? 0)} jours
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                <div className="col-sm-4 col-md-4">
                    <MainCalculatorsList />
                </div>
            </div>
            <div className="row">
                <div className="col-12 col-md-8">
                    <h3 className="p-3 mb-2 bg-success text-white">Jours restants jusqu'à l'Aïd al-Adha 2026</h3>
                    <p>
                        Dans cet article, nous vous présentons le décompte détaillé pour l'Aïd al-Adha, afin que vous puissiez toujours être informé du nombre de jours restants jusqu'à l'arrivée de cette occasion honorable. Beaucoup d'entre nous se demandent combien de temps reste jusqu'à l'Aïd al-Adha, c'est pourquoi nous vous fournissons le décompte pour savoir combien de temps reste, combien de jours restent jusqu'à l'Aïd al-Adha.
                    </p>
                    <p>
                        Selon le calendrier hégirien, l'Aïd al-Adha 2026 tombera le {dayName} {nextEid.date.toLocaleDateString('fr-FR')} (grégorien) et le {moment(nextEid.date).format('iDD/iMM/iYYYY')} (hégirien). Vous pouvez voir le décompte pour l'Aïd al-Adha 2026 dans cet article.
                    </p>
                    <hr />
                    <RelatedLinks />
                    <hr />
                    <h3 className="p-3 mb-2 bg-success text-white">
                        Calculer les jours restants jusqu'à l'Aïd al-Adha
                    </h3>
                    <p>
                        Grâce au programme de décompte de l'Aïd al-Adha, vous pouvez savoir combien de jours restent jusqu'à l'Aïd al-Adha dans les calendriers grégorien et hégirien. Vous pouvez également découvrir combien de jours restent jusqu'à la fin de l'Aïd al-Adha.
                    </p>
                    <h3 className="p-3 mb-2 bg-success text-white">L'Aïd al-Adha</h3>
                    <p>
                        L'Aïd al-Adha (fête du sacrifice) est l'une des deux grandes fêtes islamiques. Elle commémore la volonté du prophète Ibrahim (Abraham) de sacrifier son fils en obéissance à Dieu. L'Aïd al-Adha est célébré le 10 Dhul Hijjah, le douzième et dernier mois du calendrier islamique.
                    </p>
                    <p>
                        Pendant l'Aïd al-Adha, les musulmans du monde entier qui peuvent se le permettre pratiquent le sacrifice (Udhiya/Qurbani) d'un animal comme un mouton, une chèvre, une vache ou un chameau. La viande est partagée entre la famille, les amis et les pauvres.
                    </p>
                    <div>
                        <br />
                        <img src={imageUrl} alt="Décompte jusqu'à l'Aïd al-Adha" style={{ width: '100%', height: 'auto' }} />
                    </div>
                    <h3 className="p-3 mb-2 bg-success text-white">
                        La signification de l'Aïd al-Adha
                    </h3>
                    <p>
                        L'Aïd al-Adha est une occasion de renforcer les liens familiaux et communautaires, de montrer de la gratitude envers Dieu, et de faire preuve de générosité envers les moins fortunés. Les musulmans commencent la journée par une prière spéciale à la mosquée, suivie du sacrifice et des festivités en famille.
                    </p>
                    <ul>
                        <li>Prière de l'Aïd à la mosquée</li>
                        <li>Sacrifice d'un animal (mouton, chèvre, vache ou chameau)</li>
                        <li>Partage de la viande avec la famille, les amis et les pauvres</li>
                        <li>Échange de vœux et de cadeaux</li>
                        <li>Visites familiales et retrouvailles</li>
                    </ul>
                </div>
            </div>
            <MobileUnderCalAds />
        </div>
    );
}

export default EidAdha;
